import React from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
// import SaveIcon from "@mui/icons-material/Save";
// import CheckIcon from "@mui/icons-material/Check";

const CustomLoadingButton = ({ loading, success, onClick, children }) => {
    return (
        <Button
            variant="contained"
            disabled={loading}
            onClick={onClick}
            sx={{
                bgcolor: success ? 'success.main' : 'primary.main',
            }}
        >
            {loading ? (
                <CircularProgress size={24} sx={{ color: 'white' }} />
            ) : success ? (
                'Saved!'
            ) : (
                children
            )}
        </Button>
    );
};

export default CustomLoadingButton;
